import classNames from 'classnames'
import React, { ElementType, FC } from 'react'
import { CellItem } from '../../Row/Cell'
import * as css from './Alignment.css'
export enum Alignment {
  CENTER = 'center',
  LEFT = 'start',
  RIGHT = 'end'
}

export enum VerticalAlignment {
  CENTER = 'center',
  END = 'end',
  START = 'start'
}

const HorizontalClasses = {
  [Alignment.LEFT]: 'm-r-auto',
  [Alignment.CENTER]: 'justify-center'
}

const withAlignment: (
  CellElement: ElementType,
  horizontalAlignment: Alignment,
  verticalAlignment: VerticalAlignment,
  classes?: string
) => FC<CellItem> =
  (CellElement, horizontalAlignment, verticalAlignment, classes) => props =>
    (
      <div
        className={classNames(
          css['padding'],
          HorizontalClasses[horizontalAlignment],
          `align-self-${verticalAlignment}`,
          'w-100',
          classes
        )}
      >
        <CellElement {...props} />
      </div>
    )

export default withAlignment
